// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EnrollmentExtV2Api = class EnrollmentExtV2Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param programId
     * @param EnrollmentRequestModel
     * @param x_program_id The program id from the list of allowed program ids
     */
    async basicEnrollmentCreate(programId, EnrollmentRequestModel, x_program_id) {
        const _url_ = '/enrollment_ext/v2/BasicEnrollment/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling basicEnrollmentCreate.');
        }
        // verify required parameter 'EnrollmentRequestModel' is not null or undefined
        if (EnrollmentRequestModel === null || EnrollmentRequestModel === undefined) {
            throw new Error('Required parameter EnrollmentRequestModel was null or undefined when calling basicEnrollmentCreate.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(EnrollmentRequestModel, "EnrollmentRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentResultModelResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param EnrollmentInsVerRequestModel
     * @param x_program_id The program id from the list of allowed program ids
     */
    async enrollmentCreate(programId, EnrollmentInsVerRequestModel, x_program_id) {
        const _url_ = '/enrollment_ext/v2/Enrollment/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentCreate.');
        }
        // verify required parameter 'EnrollmentInsVerRequestModel' is not null or undefined
        if (EnrollmentInsVerRequestModel === null || EnrollmentInsVerRequestModel === undefined) {
            throw new Error('Required parameter EnrollmentInsVerRequestModel was null or undefined when calling enrollmentCreate.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(EnrollmentInsVerRequestModel, "EnrollmentInsVerRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentResultModelResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param EnrollmentVerifySurveyEntryRequestModel
     * @param x_program_id The program id from the list of allowed program ids
     */
    async verifySurveyAnswerCreate(programId, EnrollmentVerifySurveyEntryRequestModel, x_program_id) {
        const _url_ = '/enrollment_ext/v2/VerifySurveyAnswer/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling verifySurveyAnswerCreate.');
        }
        // verify required parameter 'EnrollmentVerifySurveyEntryRequestModel' is not null or undefined
        if (EnrollmentVerifySurveyEntryRequestModel === null || EnrollmentVerifySurveyEntryRequestModel === undefined) {
            throw new Error('Required parameter EnrollmentVerifySurveyEntryRequestModel was null or undefined when calling verifySurveyAnswerCreate.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(EnrollmentVerifySurveyEntryRequestModel, "EnrollmentVerifySurveyEntryRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentVerifySurveyEntryResultModelResponse");
        }
        return response;
    }
};
EnrollmentExtV2Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EnrollmentExtV2Api);
export { EnrollmentExtV2Api };
//# sourceMappingURL=enrollmentExtV2Api.js.map